import AgreementForm from './AgreementForm';

export default AgreementForm;
